(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["footer"]) return;
  try {
    
  customElements.whenDefined('details-disclosure').then(() => {
    class MobileDisclosure extends DetailsDisclosure {
      constructor() {
        super();
        this.reset();
        window.addEventListener('on:breakpoint-change', this.reset.bind(this));
      }

      reset() {
        const isLargeScreen = window.matchMedia(theme.mediaQueries.md).matches;
        this.disclosure.open = isLargeScreen;

        if (isLargeScreen) {
          this.toggle.setAttribute('tabindex', '-1');
          this.querySelectorAll('.disclosure, .disclosure__title, .disclosure__panel, .disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(`mobile-${cl}`);
            });
          });
        } else {
          this.toggle.removeAttribute('tabindex');
          this.querySelectorAll('.mobile-disclosure, .mobile-disclosure__title, .mobile-disclosure__panel, .mobile-disclosure__content').forEach((el) => {
            [...el.classList].filter((cl) => cl.indexOf('mobile-disclosure') === 0).forEach((cl) => {
              el.classList.remove(cl);
              el.classList.add(cl.substr(7));
            });
          });
        }
      }
    }

    customElements.define('mobile-disclosure', MobileDisclosure);
  });

  } catch(e) { console.error(e); }
})();

(function() {
  if (!__sections__["related-products"]) return;
  try {
    
var loadProductRecommendationsIntoSection = function() {
  var productRecommendationsSection = document.querySelector(".related-products");
  if (productRecommendationsSection === null) { return; }

  var request = new XMLHttpRequest();
  request.open("GET", productRecommendationsSection.dataset.url);
  request.onload = function() {
    if (request.status >= 200 && request.status < 300) {
      var container = document.createElement("div");
      container.innerHTML = request.response;
      productRecommendationsSection.innerHTML = container.querySelector(".related-products").innerHTML;
      
      // Recommendation products load hone ke baad Add to Cart forms bind karein
      bindRecommendationAddToCartForms(productRecommendationsSection);
    }
  };
  request.send();
};

function bindRecommendationAddToCartForms(sectionElement) {
  var forms = sectionElement.querySelectorAll('form[action*="/cart/add"]');

  forms.forEach(function(form) {
    form.addEventListener('submit', function(e) {
      e.preventDefault(); // Page reload / Cart redirect rokne ke liye

      var formData = new FormData(form);

      fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        body: formData
      })
      .then(function(response) {
        return response.json();
      })
      .then(function(item) {
        // Theme event dispatch karein taaki header count update ho aur Cart Drawer open ho
        document.dispatchEvent(new CustomEvent('cart:refresh', {
          bubbles: true,
          detail: { item: item }
        }));

        // Alternative event names for standard themes (Dawn, Clean/Impact, ThemeX)
        document.dispatchEvent(new CustomEvent('cart:open'));
        document.dispatchEvent(new CustomEvent('theme:cart:change'));

        // Direct DOM update fallbacks:
        if (typeof theme !== 'undefined' && theme.cartDrawer) {
          theme.cartDrawer.open();
        } else {
          var drawer = document.querySelector('.cart-drawer, #cart-drawer, drawer-cart, cart-drawer');
          if (drawer) {
            drawer.classList.add('is-open', 'active', 'open');
          }
        }
      })
      .catch(function(error) {
        console.error('Error adding to cart:', error);
      });
    });
  });
}

// Fetching on section reload & page load
document.addEventListener("shopify:section:load", function(event) {
  if (document.querySelector('[data-section-id="' + event.detail.sectionId + '"].related-products')) {
    loadProductRecommendationsIntoSection();
  }
});

loadProductRecommendationsIntoSection();

  } catch(e) { console.error(e); }
})();
})();
